var _defs, _path, _animateTransform;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthorizingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "145px",
    height: "145px",
    viewBox: "0 0 145 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: ".329%",
    x2: "42.671%",
    y1: "46.309%",
    y2: "91.099%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C6C4C4",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M160.46 237.231c-4.647 0-8.415-3.77-8.415-8.423 0-4.652 3.768-8.423 8.415-8.423 32.425 0 58.71-26.312 58.71-58.77 0-32.457-26.285-58.769-58.71-58.769-31.346 0-57.126 24.654-58.64 55.865-.226 4.646-4.171 8.23-8.813 8.004-4.642-.225-8.222-4.175-7.997-8.821C86.96 117.718 120.127 86 160.46 86c41.72 0 75.54 33.854 75.54 75.616 0 41.761-33.82 75.615-75.54 75.615zm-3.974.208c-4.753-.186-8.453-4.133-8.264-8.816.189-4.683 4.195-8.328 8.948-8.142a62.22 62.22 0 0 0 2.432.047c4.757 0 8.613 3.8 8.613 8.487 0 4.686-3.857 8.485-8.614 8.485-1.04 0-2.08-.02-3.115-.061z",
    transform: "rotate(25 308.46 -88.743)"
  })), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "1s",
    from: "360 -2 2",
    to: "0 -2 2",
    repeatCount: "indefinite"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorizingIcon);
export default __webpack_public_path__ + "static/media/authorizing-icon.bc49ee33.svg";
export { ForwardRef as ReactComponent };